import { render, staticRenderFns } from "./CampanhasAdsCadastroApp.vue?vue&type=template&id=51fe0e76&scoped=true"
import script from "./CampanhasAdsCadastroApp.vue?vue&type=script&lang=js"
export * from "./CampanhasAdsCadastroApp.vue?vue&type=script&lang=js"
import style0 from "./CampanhasAdsCadastroApp.vue?vue&type=style&index=0&id=51fe0e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fe0e76",
  null
  
)

export default component.exports